import { Component, h, Prop, State } from '@stencil/core';
import { images } from '../../../helpers/inline-images.service';

/**
 * Display a warning when user is using IE11.
 */
@Component({
    tag: 'pnl-ie11-warning',
    styleUrl: 'pnl-ie11-warning.scss'
})
export class IE11Warning {

    private message = {
        'nl_NL': 'Let op. Je gebruikt een verouderde versie van Internet Explorer. Met een verouderde browser kun je onze website helaas niet meer (goed) gebruiken. We raden je aan om een andere browser te installeren.',
        'nl_BE': 'Let op. U gebruikt een verouderde versie van Internet Explorer. Met een verouderde browser kunt u onze website helaas niet meer (goed) gebruiken. We raden u aan om een andere browser te installeren.',
        'fr_BE': 'S\'il vous plaît noter. Vous utilisez une version obsolète d\'Internet Explorer. Avec un navigateur obsolète, vous ne pouvez malheureusement plus utiliser notre site Web (correctement). Nous vous recommandons d\'installer un autre navigateur.',
        'en_GB': 'Attention. You are using an older version of Internet Explorer. Our website does not work (well) with an older browser. Please upgrade your browser.'
    }

    @State() isIE11 = false;

    /** The locale the warning is rendered in. */
    @Prop() locale = 'nl_NL';

    async componentWillLoad() {
        const userAgent = window.navigator.userAgent;
        this.isIE11 = /MSIE|Trident/.test(userAgent);
    }

    render() {
        if (this.isIE11) {
            return (
                <div class="pci-inner-container">
                    <div class="pci-alert pci-alert--warning">
                        <p class="pci-alert__text">
                            <span class="pci-alert__icon" innerHTML={images.warning}></span>
                            {this.message[this.locale]}
                        </p>
                    </div>
                </div>
            )
        }
    }
}
